import { useSettings } from '@/context/Settings';
import { DiaTalkLogo } from '../DiaTalkLogo';
import SanofiLogo from '../SanofiLogo/SanofiLogo';

import Dropdown from './Dropdown';
import { useEffect } from 'react';

export const ChooseLanguage = () => {
  const { saveSettings } = useSettings();

  useEffect(() => {
    saveSettings({ showNavLogo: false });
  }, [saveSettings]);

  return (
    <div className="animation-overlay">
      <SanofiLogo />
      <div className="login-center">
        <DiaTalkLogo className="login-center__logo" />
        <p className="login-center__text">
          DiaTalk is only available in select countries. <br /> This site is intended for healthcare professionals.
        </p>
        <Dropdown />
      </div>
    </div>
  );
};
